class BlockSlider {
	constructor() {
		this.sliders = document.querySelectorAll(".slider-images");

		if (this.sliders) {
			this.buildSliders();
		}
	}

	buildSliders() {
		this.sliders.forEach(slider => {
			const nextBtn = slider.querySelector(".swiper-next");
			const prevBtn = slider.querySelector(".swiper-prev");
			let swiper = new Swiper(slider, {
				speed: 500,
				effect: "fade",
				navigation: {
					nextEl: nextBtn,
					prevEl: prevBtn,
				}
			});
		});
	}
}